import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import Empty from '../../components/empty';
import { Popover } from '@headlessui/react';
import Fetching from "../../components/fetching";
import UserCircleIcon from "@heroicons/react/24/outline/esm/UserCircleIcon";
import ChangePasswordForm from "../../components/change_password_form";
import { updatePassword } from '../../services/api_dipendenti';
import moment from "moment";
import { getEmployeeSettings, updateEmployeeSettings } from "../../services/api_dipendenti";
import EmployeeEmailNotificationSetting from "../../components/employee_email_setting_form";
import SwitchUtenzeSection from "../../components/switch_utenze_section";
import Swal from 'sweetalert2';


export default function ProfileEmployee() {
    const { profile, token, isEmployee } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [isLoadingSetting, setIsLoadingSetting] = useState(false);
    const [originalSettings, setOriginalSettings] = useState(null);
    const [isEmployeeEmailEnabled, setIsEmployeeEmailEnabled] = useState(false);
    const [isEmployeePushEnabled, setIsEmployeePushEnabled] = useState(false);


    const hasConsultalaHRPro = profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro");

    useEffect(() => {
        if (profile) {
            setLoading(false);
        }
    }, [profile]);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                setIsLoadingSetting(true);
                const response = await getEmployeeSettings(token);
                const settings = response.data;
                
                setOriginalSettings(settings);
                setIsEmployeeEmailEnabled(settings.employee_email_enabled !== undefined ? settings.employee_email_enabled : true);
                setIsEmployeePushEnabled(settings.employee_push_notification_enabled !== undefined ? settings.employee_push_notification_enabled : true);
            } catch (err) {
                console.error("Errore durante il caricamento delle impostazioni.", err);
            } finally {
                setIsLoadingSetting(false);
            }
        };
      
        fetchSettings();
    }, [token]);
    

    const handleSettingChange = async (key, value) => {
        try {
          await updateEmployeeSettings(token, { [key]: value });
      
          if (key === "employee_email_enabled") {
            setIsEmployeeEmailEnabled(value);
          } else if (key === "employee_push_notification_enabled") {
            setIsEmployeePushEnabled(value);
          }
      
          Swal.fire({
            icon: "success",
            title: "Salvato!",
            showConfirmButton: false,
            timer: 1000,
          });
        } catch (error) {
          console.error("Errore durante il salvataggio:", error);
          Swal.fire({
            icon: "error",
            title: "Errore",
            text: "Non è stato possibile aggiornare l'impostazione.",
            confirmButtonText: "OK",
          });
        }
      };
    

    if (loading) {
        return <Fetching />;
    }

    return (
        <div>
            <Popover as="header" className={`bg-indigo-200`}>
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
                        <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                            <div className="flex justify-center my-2 py-2">
                                <h2 className="text-center text-2xl font-semibold text-indigo-800">Profilo</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </Popover>

            <main className="mt-10 pb-8">
                <div className="container mx-auto px-4">
                    <div className="sm:flex sm:items-center">
                        <div className="sm:flex-auto pl-4 pb-4">
                            <h1 className="text-base font-semibold leading-6 text-gray-900 flex items-center">
                                <UserCircleIcon className='w-8 text-indigo-800 inline-block' />
                                <span className="ml-5">I miei Dati</span>
                            </h1>
                        </div>
                    </div>
                    <div className="px-4 mb-6">
                        <SwitchUtenzeSection />
                    </div>
                    <div className="flex flex-wrap -mx-4">
                        {/* DATI ANAGRAFICI */}
                        <div className="w-full md:w-2/3 px-4 mb-5 firstStepProfilo order-1 md:order-1">
                            <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                                <div>
                                    <dl className="divide-y divide-gray-100">
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                        <dt className="text-sm font-medium text-gray-900">Nome</dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {profile?.employee?.first_name ?? ''}
                                        </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Cognome</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.employee?.last_name ?? ''}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Codice Fiscale</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.employee?.cf ?? ''}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Email Accesso App</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.employee?.email_auth ?? ''}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Email</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.employee?.email ?? ''}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Indirizzo Domicilio</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {(profile?.employee?.domicilio_indirizzo ?? '') + ', ' + (profile?.employee?.domicilio_comune?.name ?? '')}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Telefono</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.employee?.phone_number ?? ''}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Iban</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.employee?.iban ?? ''}
                                            </dd>
                                        </div>
                                        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="text-sm font-medium text-gray-900">Codice Azienda</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {profile?.company?.id ?? ''}
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        <div className="w-full md:w-1/3 px-4 order-3 md:order-2">
                            <div className="overflow-hidden bg-white shadow sm:rounded-lg p-4">
                                <h3 className="text-base font-semibold leading-7 text-gray-900">Cambia Password</h3>
                                <ChangePasswordForm updateFunction={updatePassword} />
                            </div>
                        </div>

                        <div className="w-full md:w-1/3 px-4 order-3 md:order-4">
                            <div className="overflow-hidden bg-white shadow sm:rounded-lg p-4">
                                <h3 className="text-base font-semibold leading-7 text-gray-900">Impostazioni Email / Notifiche</h3>
                                <EmployeeEmailNotificationSetting
                                    isEmailEnabled={isEmployeeEmailEnabled}
                                    isPushEnabled={isEmployeePushEnabled}
                                    isLoading={isLoadingSetting}
                                    onChangeSetting={handleSettingChange}
                                />
                            </div>
                        </div>

                        
                        {/* DATI CONTRATTO ATTIVO */}
                        {hasConsultalaHRPro && (
                            profile?.employee?.has_active_contract && (
                                <div className="w-full md:w-2/3 px-4 mb-5 order-2 md:order-3">
                                    <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                                        <div>
                                            <dl className="divide-y divide-gray-100">
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-semibold text-indigo-800">Dati Contratto Attivo</dt>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Data Inizio</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {moment(profile.employee.active_contract?.start_date).format('DD/MM/YYYY') ?? ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Data Fine</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile?.employee?.active_contract?.end_date
                                                            ? moment(profile.employee.active_contract.end_date).format('DD/MM/YYYY')
                                                            : ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Tipologia Turno</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 uppercase">
                                                        {profile.employee.active_contract?.shift_type ?? ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Ore Settimanali</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.week_hours ?? ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Tipologia Contrattuale</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.typology?.description ?? ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">CCNL</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.ccnl?.nome ?? ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Qualifica Professionale</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract.qualification?.descrizione ?? ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Livello Inquadramento</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.classification_level?.cod_livello} - {profile.employee.active_contract?.classification_level?.des_livello}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Tipo Orario</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.working_hours_type?.nome}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Retribuzione (RAL)</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.ral ? `€ ${profile.employee.active_contract.ral}` : ''}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Ente Previdenziale</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.social_security_institution?.description}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">PAT Inail</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.pat_inail}
                                                    </dd>
                                                </div>
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                                    <dt className="text-sm font-medium text-gray-900">Lavoro Stagionale</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {profile.employee.active_contract?.is_seasonal_work ? 'SI' : ''}
                                                    </dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>                
            </main>
        </div>
    );
}
